<template>
  <section class="main-feature">
    <img
      class="main-feature__icon"
      :src="require(`@/features/main-features-section/images/main-features/${feature.icon}.svg`)"
      :alt="feature.headline"
    />
    <div class="main-feature__content">
      <h3 class="main-feature__headline-container">
        <span class="main-feature__headline">
          {{ feature.headline }}
          <sup v-if="feature.new">
            {{ feature.new }}
          </sup>
        </span>
      </h3>
      <div class="main-feature__subheadline" v-html="feature.subheadline" />
    </div>
  </section>
</template>

<script>
export default {
  name: "MainFeature",
  props: {
    feature: {
      type: Object,
      default: () => {},
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
.main-feature {
  display: flex;
  flex-direction: row;
  align-items: center;

  &__headline-container {
    margin-bottom: 0;

    line-height: 0.625;

    @include media(min-width, m) {
      line-height: 1.5;
    }
  }

  &__icon {
    width: spacing(60px);
    height: spacing(60px);
    margin-right: $spacing-24;
  }

  &__headline {
    @include font-style(
      (
        xs: p1,
        m: h3
      ),
      $weight: bold,
      $color: $midnight
    );

    position: relative;

    sup {
      @include font-style(h6, $color: $red);

      position: absolute;
      top: -$spacing-4;
      right: -$spacing-8;

      transform: translateX(100%);
    }
  }

  &__subheadline {
    @include font-style(
      (
        xs: p1,
        m: p0
      )
    );
  }

  @include media(min-width, m) {
    flex-direction: column;

    &__icon {
      margin: 0 auto $spacing-24;
    }

    &__headline-container {
      margin-bottom: $spacing-8;

      text-align: center;
    }

    &__subheadline {
      text-align: center;
    }
  }
}
</style>
